import clsx from "clsx";

interface ButtonProps {
  label: string;
  onClick: () => void;
  //else is secondary
  type: "primary" | "secondary" | "link";
}

const Button: React.FC<ButtonProps> = ({ label, onClick, type }) => {
  return (
    <button
      className={clsx([
        "text-sm rounded-md px-2 py-1",
        { "bg-purple-500 hover:bg-purple-600": type === "primary" },
        { "bg-purple-300 hover:bg-purple-400": type === "secondary" },
        { "underline hover:text-purple-400": type === "link" },
        { "font-bold text-white": type !== "link" },
        { "text-xs": type === "link" },
      ])}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default Button;
